var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletConnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Wallet_Connect_logo",
    "data-name": "Wallet Connect logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.798,
    height: 13.072,
    viewBox: "0 0 20.798 13.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M10754.291,290.644l4.105-4.105,4.105,4.105,4.382-4.383,1.911,1.912-6.293,6.294-4.105-4.105-4.105,4.105-6.294-6.294,1.936-1.936Z",
    transform: "translate(-10747.997 -281.395)",
    fill: "#5194f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M10753.874,285.446l-1.847-1.846s6.084-6.739,13.571,0c-.03.018-1.846,1.846-1.846,1.846a7.437,7.437,0,0,0-5.031-2.427A6.827,6.827,0,0,0,10753.874,285.446Z",
    transform: "translate(-10748.562 -280.605)",
    fill: "#5194f4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/wallet-connect.baafeacf.svg";
export { ForwardRef as ReactComponent };